<template>
  <section class="commits-list">
    <div class="commits-list__header mb-3">
      <b class="text-nowrap">{{ $t('message.sort_by') }}</b>
      <custom-select
        class="commits-list__header-selector"
        v-model="selectedSortType"
        :options="sortTypes"
        @input="onSortTypeChange"
      ></custom-select>
      <project-branch-selector
        v-if="branch && branchModel && selectedSortType?.value === 'branch'"
        v-model="branchModel"
        class="commits-list__header-selector"
        :selected="branchModel"
        :alias="alias"
        :project-model="projectAlias"
        :placeholder="$t('message.select_branch')"
        @input="onBranchChange"
      ></project-branch-selector>
      <project-tag-selector
        v-if="selectedSortType?.value === 'tag'"
        class="commits-list__header-selector"
        v-model="tagModel"
        :selected="tagModel"
        :project-alias="projectAlias"
        :user-alias="alias"
        @input="onTagChange"
        placeholder="Тег"
      ></project-tag-selector>
    </div>
    <commit-list
      :commit-groups="commitGroups"
      :can-create-tag="getActionAvailabilityFlag(ACTION_ENUM.MANAGE_TAG_API)"
      :can-start-container="getActionAvailabilityFlag(ACTION_ENUM.EXECUTE_CI_CD)"
      @revert="getCommits"
    />
  </section>
</template>

<script>
import projectBranchSelector from '@/shared-modules/shared-components/shared/project-branch-selector';
import commitService from '@/shared-modules/modules/commit/commit.service';
import CommitList from '@shared/shared-components/commit/commit-list';
import ACTION_ENUM from '@shared/modules/custom-roles/custom-roles.constants';
import CustomSelect from '@shared/shared-components/shared/custom-select';
import ProjectTagSelector from '@/shared-modules/shared-components/shared/project-tag-selector';

export default {
  name: 'PageCommits',
  components: { projectBranchSelector, CommitList, CustomSelect, ProjectTagSelector },
  data() {
    return {
      branchModel: null,
      tagModel: null,
      selectedSortType: null,
      sortTypes: [
        { title: this.$t('message.sort_by_branch'), value: 'branch' },
        { title: this.$t('message.sort_by_tag'), value: 'tag' }
      ]
    };
  },
  computed: {
    ACTION_ENUM() {
      return ACTION_ENUM;
    },
    branch() {
      return this.$route.query?.branch || document.getElementById('currentBranch')?.value || null;
    },
    commitGroups() {
      return this.$store.getters.getCommitGroups || this.getCommits();
    },
    alias() {
      return this.$route.params?.alias;
    },
    projectAlias() {
      return this.$route.params?.projectAlias;
    },
    tag() {
      return this.$route.query?.tag || null;
    }
  },
  watch: {
    '$route.query'(newValue, oldValue) {
      if (Object.keys(oldValue)?.length > 0) {
        this.getCommits();
      }
    }
  },
  mounted() {
    if (this.tag) {
      this.selectedSortType = this.sortTypes[1];
      this.tagModel = this.tag;
      this.onTagChange();
    } else {
      this.selectedSortType = this.sortTypes[0];
      this.branchModel = this.branch;
      this.onBranchChange();
    }
    this.getCommits();
  },
  methods: {
    getActionAvailabilityFlag(action) {
      return this.$store.getters.getActionAvailabilityFlag(action);
    },
    onBranchChange() {
      if (this.$route.query.branch !== this.branchModel) {
        this.$router.push({
          query: {
            branch: this.branchModel?.title || this.branchModel || this.branch,
            tag: undefined
          }
        });
        this.branchModel = this.branchModel || this.branch;
      }
    },
    onTagChange() {
      if (this.tag !== this.tagModel) {
        this.$router.push({
          query: { tag: this.tagModel?.name, branch: undefined }
        });
      }
    },
    getCommits() {
      commitService.getCommits(this.alias, this.projectAlias, this.$route.query);
    },
    onSortTypeChange() {
      if (this.selectedSortType.value === 'tag' && this.tagModel) {
        this.onTagChange();
      } else if (this.selectedSortType.value === 'branch') {
        this.onBranchChange();
      }
    }
  }
};
</script>

<style lang="scss">
$this: '.commits-list';

#{$this} {
  #{$this}__header {
    display: flex;
    align-items: start;
    flex-direction: column;
    gap: 12px;

    @media screen and (min-width: 992px) {
      align-items: center;
      flex-direction: row;
    }

    &-selector {
      min-width: 100%;
      max-width: 180px;

      @media screen and (min-width: 992px) {
        min-width: 100px;
      }
    }
  }
}
</style>
